<template>
  <el-row class="card" :style="cardStyle">
    <el-col v-loading="loading" class="card__content">

      <div class="card__title" v-if="$slots.title">
        <slot name="title"></slot>
      </div>
      <div class="card__subtitle" v-if="$slots.subtitle">
        <slot name="subtitle"></slot>
      </div>
      <div class="card__description" v-if="$slots.description">
        <slot name="description"></slot>
      </div>

      <slot></slot>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: "Card",
  props: {
    width: {
      type: String,
      default: 'auto'
    },
    maxWidth: {
      type: String,
      default: '650px'
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  created() {

  },
  computed: {
    cardStyle() {
      return {
        width: this.width,
        maxWidth: this.maxWidth,
      }
    }
  }
}
</script>

<style scoped lang="scss">
.card {
  margin: 25px 0;
  background: #fff;
  border: 0;
  border-radius: 4px;
  padding: 16px;

  &__content {
    min-height: 50px;
  }

  &__title {
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 16px;
    color: #111;
    margin-bottom: 12px;
  }

  &__subtitle {
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 13px;
    color: #111;
  }

  &__description {
    font-style: normal;
    font-weight: normal;
    font-size: 11px;
    line-height: 13px;
    color: #111;
    margin-top: 5px;
    margin-bottom: 22px;
  }

}
</style>
